const Footer = () => {
    return (
        <footer className="site-footer">
            <p>&copy; {new Date().getFullYear()} Jerome Ronquillo. All rights reserved.</p>
            <p>
                <a href="https://github.com/jrmronquillo" target="_blank" rel="noopener noreferrer">GitHub</a> | 
                <a href="https://www.linkedin.com/in/jerome-ronquillo-mse-4063bb76/" target="_blank" rel="noopener noreferrer"> LinkedIn</a>
            </p>
        </footer>
    );
};

export default Footer;